module.exports = "../../app/cells/components/trial/top_bar/activated_cell.rb";